export const ACTIONS = {
  SET_STUDENT_QUESTION_UPDATE: 'SET_STUDENT_QUESTION_UPDATE',
  SET_STUDENT_QUESTION_METADATA: 'SET_STUDENT_QUESTION_METADATA',
};

export function storeAttemptingQuestionsPayload(payload) {
  return dispatch =>
    dispatch({
      type: ACTIONS.SET_STUDENT_QUESTION_UPDATE,
      payload,
    });
}
export function setAttemptingQuestionsMetaData(payload) {
  return dispatch =>
    dispatch({
      type: ACTIONS.SET_STUDENT_QUESTION_METADATA,
      payload,
    });
}
